import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { AppShell } from "../components/app-shell";
import { ResponsiveImage } from "../components/responsive-image";

export function NotFoundPage() {
  return (
    <AppShell eyebrow="404" backTo="/" backLabel="Na početnu">
      <div className="empty-state">
        <ResponsiveImage name="empty-state" alt="" width={1024} height={1024} sizes="340px" />
        <h1>Ovdje još nema prostora.</h1>
        <p>Stranica koju tražiš ne postoji ili je premještena.</p>
        <Link className="button button--primary" to="/">
          <ArrowLeft aria-hidden="true" /> Povratak na početnu
        </Link>
      </div>
    </AppShell>
  );
}
